
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ad-dashboard-adschedules',
	templateUrl: './ad-dashboard-adschedules.component.html',
	styleUrls: ['./ad-dashboard-adschedules.component.scss']
})

export class AdDashboardAdschedulesComponent implements OnInit {

	ngOnInit(): void {
		//
	}
}
